import { FC, forwardRef } from 'react'
import { SwatchType } from '../Swatch/Swatch'
import s from './TextSwatch.module.scss'


export interface SwatchProps extends Omit<SwatchType, "src"> {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Swatch: FC<SwatchProps> = forwardRef(
  (
    { id = "black", name = "black", value = "black", label, onChange, checked, disabled },
    ref
  ) => {
    return (
      <span className={s.root}>
        <input disabled={disabled} id={id} name={name} type='radio' className={s.swatchValue} checked={checked} value={value} onChange={onChange} />
        <label htmlFor={id} className={s.swatchLabel} title={disabled ? 'Not available' : undefined}>
          <span className={s.label}>{label ?? value}</span>
        </label>
      </span>
    )
  }
)
Swatch.displayName = 'Swatch'
export default Swatch
